import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';

export class SeeAllPromotionsApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.SeeAllPromotions;

  constructor(private isMenu?: boolean) {

  }

  getPayload(): any {
    return {
      isMenu: this.isMenu
    };
  }
}
